'use client';

import { api } from '@/services/api';
import { ProductProps } from '@/types/Product';
import { useCallback, useContext, useEffect, useState } from 'react';
import ProductsGrid from '../../ProductsGrid';
import { CartContext } from '@/contexts/CartContext';
import { FaEye } from 'react-icons/fa6';
import { Flex } from '@chakra-ui/react';

const ViewProducts = () => {
  const [products, setProducts] = useState<ProductProps[]>([]);

  const { viewedProducts } = useContext(CartContext);

  const getProducts = useCallback(async (p: string[]) => {
    // Um produto entretanto desativado/removido não pode derrubar a secção
    // inteira — cada pedido falha de forma independente e só os produtos
    // ainda disponíveis são mostrados.
    const results = await Promise.allSettled(
      p.map(async (productSlug) => {
        const response = await api.get('/product/' + productSlug);
        return response.data;
      }),
    );

    setProducts(
      results
        .filter((r): r is PromiseFulfilledResult<ProductProps> => r.status === 'fulfilled')
        .map((r) => r.value),
    );
  }, []);

  useEffect(() => {
    if (viewedProducts.length > 0) {
      getProducts(viewedProducts);
    }
  }, [getProducts, viewedProducts]);

  if (products.length === 0) return null;

  return (
    <Flex
      width="100%"
      maxW="breakpoint-xl"
      flexDirection="column"
      mt="20px"
    >
      <ProductsGrid
        IconReact={FaEye}
        title="Vistos Recentemente"
        products={products}
      />
    </Flex>
  );
};

export default ViewProducts;
